import React from 'react';
import { translate } from 'react-i18next';

import { Segment, Button, Container, Grid, Message, Icon } from 'semantic-ui-react';

var style= {
    container: {
        height:'100%', 
        padding:'10px 10px 100px 10px',
        textAlign: 'center'
    },
    containerDiv: {
        height:'100%', 
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '40rem'
    },
    segment: {
        height: '100%',
        textAlign: 'center'
    },
    grid: {
        height: '100%'
    },
    ratings: {
    }
};

const UnknownChallenge = ({t, challenge}) => (
    <Container style={style.container}>
        <div style={style.containerDiv}>
        <Segment style={style.segment}>
            <Grid style={style.grid} centered columns={1}>
                <Grid.Row verticalAlign='top'>
                    {challenge.category.icon &&
                        <Icon size='huge' className={challenge.category.icon}></Icon> 
                    }
                </Grid.Row>
                <Grid.Row verticalAlign='middle'>
                    <Grid.Column verticalAlign='middle'>
                        {challenge.description} 
                    </Grid.Column>
                </Grid.Row>
              
                <Grid.Row verticalAlign='bottom'>
                    <Grid.Column verticalAlign='bottom' textAlign='left'>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Segment>
        <Message positive>{t('New Challenge Type. Coming Soon...')}</Message>
    </div>
    </Container>
);

export default translate('challenges')(UnknownChallenge);



// WEBPACK FOOTER //
// ./src/modules/challenges/types/UnknownChallenge.js